// extracted by mini-css-extract-plugin
export var bottomSplash = "style-module--bottomSplash--GYSkB";
export var gadgetPosition = "style-module--gadgetPosition--lW9pK";
export var image2 = "style-module--image2--zqNEl";
export var imageSplash = "style-module--imageSplash--cIuPZ";
export var root = "style-module--root--2qqhh";
export var rowWrapper = "style-module--rowWrapper--FDtMV";
export var whoWeAreWrapper = "style-module--whoWeAreWrapper--42KgQ";